/**
 * Pure helpers shared by player modules.
 */

export const fmtTime = (s) => {
  if (!isFinite(s) || s < 0) return '0:00:00';
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const x = Math.floor(s % 60);
  return h + ':' + String(m).padStart(2, '0') + ':' + String(x).padStart(2, '0');
};

export const fmtTimeShort = (s) => {
  if (!isFinite(s) || s < 0) return '0:00';
  const m = Math.floor(s / 60);
  const x = Math.floor(s % 60);
  const ms = Math.floor((s % 1) * 100);
  return m + ':' + String(x).padStart(2, '0') + '.' + String(ms).padStart(2, '0');
};

const ESC_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
export const escAttr = (s) => String(s ?? '').replace(/[&<>"']/g, c => ESC_MAP[c]);
export const esc = escAttr;

/** Stop a keyboard event from reaching native video controls. */
export const hijack = (e) => {
  e.preventDefault();
  e.stopImmediatePropagation();
  e.stopPropagation();
};

// eslint-disable-next-line no-console -- zentraler dbg-Wrapper (das EINE erlaubte console.log)
export const dbg = (...a) => { try { console.log('[zap-player]', ...a); } catch { /* noop */ } };
